import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentInfoComponent {
  @Input() cardNumber: number;
  @Input() amount: number;

  @Input()
  set name(value: string) {
    this._name = value;
    this.defineIcon(value);
  }

  get name(): string {
    return this._name;
  }

  private _name: string;
  ///Todo check system names
  private allowedPayingSystems = ['mastercard', 'visa', 'amex'];
  protected icon: string;

  private defineIcon(name: string): void {
    name = name.toLowerCase();

    if (this.allowedPayingSystems.includes(name)) {
      this.icon = name;
      return;
    }

    this.icon = '';
  }
}
